import { ProtocolDeleteTxParams, ProtocolDeployTxParams, ProtocolUpdateTxParams, toJson, WalletTxParams } from '../../Commons';
import { ProtocolEntity } from '../../Entities/Protocol.Entity';
import { SmartDBTxApiCalls } from '../index.exports.BtnHandlers.TxApiCalls';
import { fetchWrapper } from '../../lib/index.exports';

export class ProtocolTxApiCalls extends SmartDBTxApiCalls {
    protected static _Entity = ProtocolEntity;

    // #region api tx

    public static async deployTxApi(walletTxParams: WalletTxParams, txParams: ProtocolDeployTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `ProtocolDeployTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/deploy`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - deployTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - deployTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async updateTxApi(walletTxParams: WalletTxParams, txParams: ProtocolUpdateTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `ProtocolUpdateTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/update`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - updateTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - updateTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async deleteTxApi(walletTxParams: WalletTxParams, txParams: ProtocolDeleteTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `ProtocolDeleteTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - deleteTxApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - deleteTxApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api tx
}
